import { ApiClientError, type ApiMeta } from '@/lib/http-core';

/**
 * adminFetch 실패 응답 → ApiClientError(BE error.code·message·traceId 보존).
 * `throw new Error(\`… failed: 400\`)` 로 던지면 friendlyMessage 가 BE 사유(예: base64 이미지 저장 차단 400
 * "상품 상세에 이미지 데이터를 직접 넣을 수 없습니다…")를 보여 줄 수 없다. 본문이 JSON envelope 가 아니면
 * 메시지 없이 상태 코드만 실어 friendlyMessage 가 상태별 문구로 바꾸게 한다.
 */
export const errorFromResponse = async (res: Response): Promise<ApiClientError> => {
  let code = `HTTP_${res.status}`;
  let message = '';
  let details: Record<string, unknown> | null = null;
  let meta: ApiMeta | undefined;
  try {
    const env = (await res.json()) as {
      error?: { code?: string; message?: string; details?: Record<string, unknown> | null } | null;
      meta?: ApiMeta;
    };
    if (env?.error) {
      code = env.error.code ?? code;
      message = env.error.message ?? '';
      details = env.error.details ?? null;
    }
    meta = env?.meta;
  } catch {
    // 본문 없음/비 JSON — 상태 코드만.
  }
  return new ApiClientError({ code, message, details }, { status: res.status, ...(meta ? { meta } : {}) });
};
